// extracted by mini-css-extract-plugin
module.exports = {"year":"PriorApprovalsTable_year__2kL10"};